export const ELIGIBILITY_STEP_STATUS = {
  CRITICAL_REQUIRED: 0, // step is not done and will be marked as red
  REQUIRED: 1, // step is not done and will be marked as yellow
  DONE: 2, // step is done
};

export const END_OF_PAY_PERIOD_DAY_OPTIONS = [
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 7, label: 'Sunday' },
];

export const ELIGIBILITY_STEPS = {
  ACTIVE_FINANCING: 'activeFinancing',
  COMMISSION_SPLITS: 'commissionSplits',
  CREDIT_TO_CASH_RATIO: 'creditToCashRatio',
  BARBER_BANK_ACCOUNTS: 'barberBankAccounts',
};
